import { Action } from '@ngrx/store';
import { IAccountingDistributionExternal } from '../../../commons';

export enum AccountingDistributionExternalActionTypes {
  LoadAccountingDistributionExternalState = '[AccountingDistributionExternal] Load AccountingDistributionExternal State',
  LoadAccountingDistributionExternalStateSuccess = '[AccountingDistributionExternal] Load AccountingDistributionExternal State Success',
  LoadAccountingDistributionExternalStateFail = '[AccountingDistributionExternal] Load AccountingDistributionExternal State Fail',
  AccountingDistributionExternalScreenErrorReset = '[AccountingDistributionExternal] AccountingDistributionExternal Screen Error Reset'

}

export class LoadAccountingDistributionExternalState implements Action {
  readonly type = AccountingDistributionExternalActionTypes.LoadAccountingDistributionExternalState;
}

export class LoadAccountingDistributionExternalStateSuccess implements Action {
  readonly type = AccountingDistributionExternalActionTypes.LoadAccountingDistributionExternalStateSuccess;
  constructor(public payload: IAccountingDistributionExternal ) {}
}

export class LoadAccountingDistributionExternalStateFail implements Action {
  readonly type = AccountingDistributionExternalActionTypes.LoadAccountingDistributionExternalStateFail;
  constructor(public payload: any) {}
}

export class AccountingDistributionExternalScreenErrorReset implements Action {
  readonly type = AccountingDistributionExternalActionTypes.AccountingDistributionExternalScreenErrorReset;
}

export type AccountingDistributionExternalActions = 
  LoadAccountingDistributionExternalState
  | LoadAccountingDistributionExternalStateSuccess
  | LoadAccountingDistributionExternalStateFail
  | AccountingDistributionExternalScreenErrorReset;